<div class="journal-header">
  <h3>{{ 'admin.journal.titre' | traduire }}</h3>
  <button class="btn-vider" (click)="vider()">{{ 'admin.journal.vider' | traduire }}</button>
</div>

<table class="table-liste">
  <thead>
    <tr>
      <th>{{ 'admin.journal.dateHeure' | traduire }}</th>
      <th>{{ 'admin.journal.action' | traduire }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let entree of entrees">
      <td>{{ entree.dateAction }}</td>
      <td>{{ entree.texte }}</td>
    </tr>
    <tr *ngIf="entrees.length === 0">
      <td colspan="2" style="text-align:center; color:#888;">{{ 'admin.journal.vide' | traduire }}</td>
    </tr>
  </tbody>
</table>
